"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectSortedFetchedPlans = exports.selectFetchedPlans = exports.amountInRechargerCompanyCurrency = void 0;
var end2end_1 = require("@hudled/end2end");
var lodash_1 = require("lodash");
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var reselect_1 = require("reselect");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var utils_1 = require("utils/selectors/utils");
var amountInRechargerCompanyCurrency = function (rechargerCompany) { return function (recharge) {
    var _a;
    var exchangeRate = rechargerCompany.baseCurrency && ((_a = recharge.fx) === null || _a === void 0 ? void 0 : _a[rechargerCompany.baseCurrency]);
    return exchangeRate ? recharge.amount * exchangeRate : recharge.amountInAccFirmCurrency;
}; };
exports.amountInRechargerCompanyCurrency = amountInRechargerCompanyCurrency;
exports.selectFetchedPlans = (0, reselect_1.createSelector)(ordered_1.selectRecharges, single_1.selectMyRechargerCompany, (0, utils_1.makeSelectData)('recharged_vendors'), function (recharges, rechargerCompany, vendorsMap) {
    if (!vendorsMap || !recharges || !rechargerCompany) {
        return undefined;
    }
    var rechargesGroups = Object.values((0, groupBy_1.default)(recharges, function (r) { return "".concat(r.rechVendorId, "-").concat(r.plan); }));
    return rechargesGroups
        .map(function (rechargesGroup) {
        var _a, _b;
        var _c = rechargesGroup[0], rechVendorId = _c.rechVendorId, name = _c.plan;
        if (!rechVendorId || !name) {
            return undefined;
        }
        var rechVendor = vendorsMap[rechVendorId];
        var id = "".concat(rechVendorId, "-").concat(name);
        var isExcluded = rechVendorId && !!((_b = (_a = rechargerCompany.excludedPlansMap) === null || _a === void 0 ? void 0 : _a[rechVendorId]) === null || _b === void 0 ? void 0 : _b.includes(name));
        var count = rechargesGroup.length;
        var excludedCharges = rechargesGroup.filter(function (r) { return r.isExcluded; });
        var newCharges = rechargesGroup.filter(function (r) { return r.status === 'new' && !r.isExcluded; });
        var invoicedCharges = rechargesGroup.filter(function (r) { return r.status !== 'new' && !r.isExcluded; });
        var excludedCount = excludedCharges.length;
        var newChargesCount = newCharges.length;
        var invoicedCount = invoicedCharges.length;
        var totalInAccFirmCurrency = (0, sumBy_1.default)(rechargesGroup, (0, exports.amountInRechargerCompanyCurrency)(rechargerCompany));
        var totalExcludedInAccFirmCurrency = (0, sumBy_1.default)(excludedCharges, (0, exports.amountInRechargerCompanyCurrency)(rechargerCompany));
        var totalNewInAccFirmCurrency = (0, sumBy_1.default)(newCharges, (0, exports.amountInRechargerCompanyCurrency)(rechargerCompany));
        var totalInvoicedInAccFirmCurrency = (0, sumBy_1.default)(invoicedCharges, (0, exports.amountInRechargerCompanyCurrency)(rechargerCompany));
        return ({
            id: id,
            count: count,
            excludedCount: excludedCount,
            newChargesCount: newChargesCount,
            invoicedCount: invoicedCount,
            rechVendorId: rechVendorId,
            rechVendor: rechVendor,
            name: name,
            isExcluded: isExcluded,
            totalInAccFirmCurrency: totalInAccFirmCurrency,
            totalExcludedInAccFirmCurrency: totalExcludedInAccFirmCurrency,
            totalNewInAccFirmCurrency: totalNewInAccFirmCurrency,
            totalInvoicedInAccFirmCurrency: totalInvoicedInAccFirmCurrency,
        });
    })
        .filter(end2end_1.notFalsy);
});
exports.selectSortedFetchedPlans = (0, reselect_1.createSelector)(exports.selectFetchedPlans, function (recharges) { return recharges && (0, lodash_1.sortBy)(recharges, 'id'); });
